import { toastr } from 'Helpers/ToastHelper';
import { FlightTicketApiService } from 'Services/ApiServices';
import RestClient from 'Services/RestClientService';
import F2WCustomLogger from 'Services/F2WCustomLogger';

/**
 * Converts notification email data (string, array of strings, or array of objects)
 * into the react-select format [{ label, value }].
 * Shared between New ticket and TicketProfile FlightInfoSection components.
 * @param {string|Array|null|undefined} emails - Email data in any supported format.
 * @returns {Array<{label: string, value: string}>} Formatted options for react-select.
 */
export const processEmailsForDisplay = (emails) => {
  if (!emails) return [];

  if (typeof emails === 'string') {
    return emails
      .split(',')
      .map((email) => email.trim())
      .filter((email) => email)
      .map((email) => ({ label: email, value: email }));
  }

  if (Array.isArray(emails)) {
    return emails
      .filter((email) => email != null)
      .map((email) => {
        if (typeof email === 'string') return { label: email, value: email };
        if (typeof email === 'object' && email.value) return { label: email.value, value: email.value };
        return null;
      })
      .filter(Boolean);
  }

  return [];
};

/**
 * Returns the assignment date label suffix based on the flight direction.
 * Shared between New ticket and TicketProfile FlightInfoSection components.
 * @param {string|null|undefined} direction - The flight direction value.
 * @returns {string} 'Start' for arriving, 'End' for other directions, or '' if no direction.
 */
export const getAssignmentDateLabel = (direction) => {
  if (!direction) return '';
  return direction.toLowerCase() === 'arriving' ? 'Start' : 'End';
};

/**
 * TUI email validation regex. Only @tui.com and @tui.de domains are allowed.
 */
export const TUI_EMAIL_REGEX = /^[^\s@]+@(?:tui\.com|tui\.de)$/i;

export const setGreenLight = (flightTicketId, gridRef, createServerSideDatasource, dispatch) => {
  RestClient.Post(`flight-ticket/set-greenLight/${flightTicketId}`)
    .then((response) => {
      if (response) {
        toastr.success('Success', 'Changed to greenlighted.');
        gridRef.current.api.updateGridOptions({ serverSideDatasource: createServerSideDatasource(dispatch, gridRef) });
      } else {
        toastr.error('Error', "Can't change status.");
      }
    })
    .catch((error) => {
      F2WCustomLogger.error('Error setting greenlight', error, { flightTicketId });
    });
};

export const handleDeleteFlightTicket = (flightTicketId, gridRef, createServerSideDatasource, dispatch) => {
  FlightTicketApiService.delete(flightTicketId)
    .then((response) => {
      if (response) {
        toastr.success('Success', 'Removed!');
        gridRef.current.api.updateGridOptions({ serverSideDatasource: createServerSideDatasource(dispatch, gridRef) });
      } else {
        toastr.error('Error', response.message);
      }
    })
    .catch((error) => {
      F2WCustomLogger.error('Error deleting flight ticket', error, { flightTicketId });
    });
};
